import React from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import IapProductIconsPanel from "../../pages/advertisement/IapProductIconsPanel";
import StripeProductIconsPanel from "../../pages/advertisement/StripeProductIconsPanel";

/** Stripe dashboard products — see docs/stripe/product-policy.md. */
const STRIPE_PRODUCT_ROWS = [
    {
        name: "Web Premium",
        priceKeys: "starter_fun_bundle, classic_challenge, pack300",
        note: "Main product — puzzle unlock bundles and the 300 Coins pack are prices under it.",
    },
    {
        name: "Tutor Standard",
        priceKeys: "tutor_standard_monthly, tutor_standard_yearly",
        note: "Lesson tools for tutors — $4.99 / month or $49 / year.",
    },
    {
        name: "Assistant coins",
        priceKeys: "assistant_coins_2000",
        note: "Retired web pack art is kept here; IAP uses the 2000 Assistant packet PNG.",
    },
    {
        name: "AI Assistant Credit",
        priceKeys: "ai_assistant_credit",
        note: "200 AI credits · $1.99 — assistant usage.",
    },
];

/**
 * Admin AD → Product Icon: App Store IAP art + Stripe dashboard product images.
 */
export default function ProductIconsPage() {
    return (
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                Product Icon
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 760 }}>
                All 512×512 product images in one place — App Store / Play IAP packs and Stripe
                dashboard products. Download PNG and upload it on the store or Stripe → Product
                catalog → product → Edit product → image.
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5 }}>
                App Store / IAP
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 720 }}>
                Master Pass, Pro Pack, Pocket Pack, and the 2000 Assistant packet. Shared by Sliding
                Puzzle Quest and Jigsaw Muse.
            </Typography>
            <IapProductIconsPanel />

            <Typography variant="h6" sx={{ fontWeight: 800, mt: 4, mb: 0.5 }}>
                Stripe
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 720 }}>
                Web Premium is the main consumer product; Tutor Standard is the tutor plan.
                Assistant coins and AI Assistant Credit are add-on packs.
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                Products &amp; price keys
            </Typography>
            <Box sx={{ overflowX: "auto", mb: 3 }}>
                <Table size="small" sx={{ minWidth: 640 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, width: "22%" }}>Product</TableCell>
                            <TableCell sx={{ fontWeight: 700, width: "34%" }}>Price keys</TableCell>
                            <TableCell sx={{ fontWeight: 700 }}>Notes</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {STRIPE_PRODUCT_ROWS.map((row) => (
                            <TableRow key={row.name} hover>
                                <TableCell>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                        {row.name}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="caption" color="text.secondary">
                                        <code>{row.priceKeys}</code>
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" color="text.secondary">
                                        {row.note}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>

            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                Stripe product icons
            </Typography>
            <StripeProductIconsPanel />
        </Box>
    );
}
